import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import api from "../../../api/api";
import { useRef } from "react";
import ReactToPrint, { useReactToPrint } from "react-to-print";

const ListInvoice = () => {
  const [invoiceList, setInvoiceList] = useState([]);
  const [change, setChange] = useState(false)
  const [viewMore, setViewMore] = useState(true)


  useEffect(() => {
    api
      .get("/transactions/invoices/")
      .then((response) => {
        // console.log(response.data);
        setInvoiceList(response.data);
      })
      .catch((err) => {
        toast.error("Something went wrong");
      });
  }, [change]);


  const handleApprove = (id) => {
      api.post(`/transactions/invoices/${id}/approve/`)
      .then(respones=> {
         setChange(!change)
          toast.success("Approved Successfully")
          
      }).catch(err=> {
        toast.error("Something went wrong")
      })
  }
const printRef=useRef(null)
const print= useReactToPrint({
  content:()=>printRef.current
})

const handleSearch = (e) => {

  api.get(`/transactions/invoices/?search=${e.target.value}`)
  .then(response=> {
    // console.log(response.data)
    setInvoiceList(response.data)
  }).catch(error=> {
    console.log(error)
  })

}


  return (
    <div className="">
      <h1 className="text-primary-red mt-2 text-center text-3xl font-bold lg:!mt-6">
        Invoice List
      </h1>
      <div className="">
        <img
          src="../../images/title-border.png"
          alt=""
          className="mx-auto mt-4"
        />
      </div>
      <div className="">
        <img src="../images/title-border.png" alt="" className="mx-auto mt-4" />
      </div>
      {/*  table */}
      <div className="w-full md:px-10">
        <div className="flex flex-col">
          <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div className="inline-block min-w-full py-4 sm:px-6 lg:px-8">
              <div className="wrapper overflow-atuo">
                {/* search */}
                <div className="flex justify-between">
                  <input
                    placeholder="Search Company Name"
                    type="search"
                    onChange={(e)=> handleSearch(e)}
                    className="my-3 rounded-lg border border-black p-3"
                  />
                  <input
                    placeholder="Search Invoice Date"
                    type="search"
                    onChange={(e)=> handleSearch(e)}
                    className="my-3 rounded-lg border border-black p-3"
                  />
                </div>
                <table ref={printRef} className="common w-full border-collapse text-center">
                  <thead className="font-Bree bg-primary-red text-lg font-bold">
                    <tr>
                      <th
                        scope="col"
                        className="!w-[20px] px-4 py-4 text-sm font-medium text-white"
                      >
                        SN.
                      </th>
                      <th
                        scope="col"
                        className="py-4 text-sm font-medium text-white"
                      >
                        I. No
                      </th>
                      <th
                        scope="col"
                        className="py-4 text-sm font-medium text-white"
                      >
                        Date
                      </th>
                      <th
                        scope="col"
                        className="py-4 text-sm font-medium text-white"
                      >
                        Company name
                      </th>
                      <th
                        scope="col"
                        className="py-4 text-sm font-medium text-white"
                      >
                        Total Amount
                      </th>
                      <th
                        scope="col"
                        className="py-4 text-sm font-medium text-white"
                      >
                        View
                      </th>
                      <th
                        scope="col"
                        className="py-4 text-sm font-medium text-white"
                      >
                        Status
                      </th>
                    </tr>
                  </thead>
                  <tbody className="font-Acme">
                    {invoiceList.length < 1  && "No Data Found ...."}
                    {invoiceList?.slice(0, `${viewMore ? 10 : invoiceList.length}`).map((item, i) => {
                      console.log("invoiceList",item)
                      return (
                        <tr className="trow border-b bg-white" key={i}>
                          <td className="w-[5px] whitespace-nowrap border border-slate-700 py-3 px-6 text-sm font-light leading-[0px] text-gray-900">
                            {i + 1}
                          </td>
                          <td className="whitespace-nowrap border border-slate-700 py-3 px-6 text-sm font-light leading-[0px] text-gray-900">
                            {item.id}
                          </td>
                          <td className="w-[200px] whitespace-nowrap border border-slate-700 text-sm font-light text-gray-900">
                           { item.created_at.split('T')[0] }
                          </td>
                          <td className="w-[200px] whitespace-nowrap border border-slate-700 p-0 text-sm font-light text-gray-900">
                            {/* Abc pvt ltd */}
                            {item.company_name}
                          </td>
                          <td className="w-[200px] whitespace-nowrap border border-slate-700 p-0 text-sm font-light text-gray-900">
                           {item?.total_amount}
                          </td>
                          <td className="w-[200px] flex gap-3 whitespace-nowrap border border-slate-700 p-0 text-sm font-light text-gray-900">
                            <a href="" className="my-1">
                              <svg
                                className="mx-auto h-6 w-6"
                                xmlns="http://www.w3.org/2000/svg"
                                aria-hidden="true"
                                role="img"
                                preserveAspectRatio="xMidYMid meet"
                                viewBox="0 0 32 32"
                              >
                                <circle
                                  cx={16}
                                  cy={16}
                                  r={4}
                                  fill="currentColor"
                                />
                                <path
                                  fill="currentColor"
                                  d="M30.94 15.66A16.69 16.69 0 0 0 16 5A16.69 16.69 0 0 0 1.06 15.66a1 1 0 0 0 0 .68A16.69 16.69 0 0 0 16 27a16.69 16.69 0 0 0 14.94-10.66a1 1 0 0 0 0-.68ZM16 22.5a6.5 6.5 0 1 1 6.5-6.5a6.51 6.51 0 0 1-6.5 6.5Z"
                                />
                              </svg>
                            </a>

                            <button  onClick={()=> handleApprove(item.id)}
                            className="bg-primary-red rounded-2xl my-1 p-1 px-2 text-white"
                             >
                               Approve
                            </button>

                          </td>
                          <td className="w-[200px] whitespace-nowrap border border-slate-700 p-0 text-sm font-light text-gray-900">
                            {item.status}
                          </td>
                        </tr>
                      );
                    })}
                    {/* <tr className="trow border-b bg-white">
                      <td className="w-[5px] whitespace-nowrap border border-slate-700 py-3 px-6 text-sm font-light leading-[0px] text-gray-900">
                        1
                      </td>
                      <td className="whitespace-nowrap border border-slate-700 py-3 px-6 text-sm font-light leading-[0px] text-gray-900">
                        1
                      </td>
                      <td className="w-[200px] whitespace-nowrap border border-slate-700 text-sm font-light text-gray-900">
                        2078/12/1
                      </td>
                      <td className="w-[200px] whitespace-nowrap border border-slate-700 p-0 text-sm font-light text-gray-900">
                        Abc pvt ltd
                      </td>
                      <td className="w-[200px] whitespace-nowrap border border-slate-700 p-0 text-sm font-light text-gray-900">
                        15000
                      </td>
                      <td className="w-[200px] whitespace-nowrap border border-slate-700 p-0 text-sm font-light text-gray-900">
                        <a href="">
                          <svg
                            className="mx-auto h-6 w-6"
                            xmlns="http://www.w3.org/2000/svg"
                            aria-hidden="true"
                            role="img"
                            preserveAspectRatio="xMidYMid meet"
                            viewBox="0 0 32 32"
                          >
                            <circle cx={16} cy={16} r={4} fill="currentColor" />
                            <path
                              fill="currentColor"
                              d="M30.94 15.66A16.69 16.69 0 0 0 16 5A16.69 16.69 0 0 0 1.06 15.66a1 1 0 0 0 0 .68A16.69 16.69 0 0 0 16 27a16.69 16.69 0 0 0 14.94-10.66a1 1 0 0 0 0-.68ZM16 22.5a6.5 6.5 0 1 1 6.5-6.5a6.51 6.51 0 0 1-6.5 6.5Z"
                            />
                          </svg>
                        </a>
                      </td>
                      <td className="w-[200px] whitespace-nowrap border border-slate-700 p-0 text-sm font-light text-gray-900">
                        Processing
                      </td>
                    </tr> */}
                    {/* <tr className="trow border-b bg-white">
                      <td className="w-[5px] whitespace-nowrap border border-slate-700 py-3 px-6 text-sm font-light leading-[0px] text-gray-900">
                        1
                      </td>
                      <td className="whitespace-nowrap border border-slate-700 py-3 px-6 text-sm font-light leading-[0px] text-gray-900">
                        1
                      </td>
                      <td className="w-[200px] whitespace-nowrap border border-slate-700 text-sm font-light text-gray-900">
                        2078/12/1
                      </td>
                      <td className="w-[200px] whitespace-nowrap border border-slate-700 p-0 text-sm font-light text-gray-900">
                        Abc pvt ltd
                      </td>
                      <td className="w-[200px] whitespace-nowrap border border-slate-700 p-0 text-sm font-light text-gray-900">
                        15000
                      </td>
                      <td className="w-[200px] whitespace-nowrap border border-slate-700 p-0 text-sm font-light text-gray-900">
                        <a href="">
                          <svg
                            className="mx-auto h-6 w-6"
                            xmlns="http://www.w3.org/2000/svg"
                            aria-hidden="true"
                            role="img"
                            preserveAspectRatio="xMidYMid meet"
                            viewBox="0 0 32 32"
                          >
                            <circle cx={16} cy={16} r={4} fill="currentColor" />
                            <path
                              fill="currentColor"
                              d="M30.94 15.66A16.69 16.69 0 0 0 16 5A16.69 16.69 0 0 0 1.06 15.66a1 1 0 0 0 0 .68A16.69 16.69 0 0 0 16 27a16.69 16.69 0 0 0 14.94-10.66a1 1 0 0 0 0-.68ZM16 22.5a6.5 6.5 0 1 1 6.5-6.5a6.51 6.51 0 0 1-6.5 6.5Z"
                            />
                          </svg>
                        </a>
                      </td>
                      <td className="w-[200px] whitespace-nowrap border border-slate-700 p-0 text-sm font-light text-gray-900">
                        Processing
                      </td>
                    </tr>
                    <tr className="trow border-b bg-white">
                      <td className="w-[5px] whitespace-nowrap border border-slate-700 py-3 px-6 text-sm font-light leading-[0px] text-gray-900">
                        1
                      </td>
                      <td className="whitespace-nowrap border border-slate-700 py-3 px-6 text-sm font-light leading-[0px] text-gray-900">
                        1
                      </td>
                      <td className="w-[200px] whitespace-nowrap border border-slate-700 text-sm font-light text-gray-900">
                        2078/12/1
                      </td>
                      <td className="w-[200px] whitespace-nowrap border border-slate-700 p-0 text-sm font-light text-gray-900">
                        Abc pvt ltd
                      </td>
                      <td className="w-[200px] whitespace-nowrap border border-slate-700 p-0 text-sm font-light text-gray-900">
                        15000
                      </td>
                      <td className="w-[200px] whitespace-nowrap border border-slate-700 p-0 text-sm font-light text-gray-900">
                        <a href="">
                          <svg
                            className="mx-auto h-6 w-6"
                            xmlns="http://www.w3.org/2000/svg"
                            aria-hidden="true"
                            role="img"
                            preserveAspectRatio="xMidYMid meet"
                            viewBox="0 0 32 32"
                          >
                            <circle cx={16} cy={16} r={4} fill="currentColor" />
                            <path
                              fill="currentColor"
                              d="M30.94 15.66A16.69 16.69 0 0 0 16 5A16.69 16.69 0 0 0 1.06 15.66a1 1 0 0 0 0 .68A16.69 16.69 0 0 0 16 27a16.69 16.69 0 0 0 14.94-10.66a1 1 0 0 0 0-.68ZM16 22.5a6.5 6.5 0 1 1 6.5-6.5a6.51 6.51 0 0 1-6.5 6.5Z"
                            />
                          </svg>
                        </a>
                      </td>
                      <td className="w-[200px] whitespace-nowrap border border-slate-700 p-0 text-sm font-light text-gray-900">
                        Processing
                      </td>
                    </tr> */}
                  </tbody>
                </table>
                {/* print button */}
                <div className="bg-primary-green ml-10 mt-3 inline-flex gap-2 rounded-md px-5 py-3 font-bold text-white">
                  <button onClick={print}>Print</button>
                </div>
                <div className="bg-primary-blue ml-10 mt-3 inline-flex gap-2 rounded-md px-5 py-3 font-bold text-white">
                {viewMore ? <button onClick={() => setViewMore(false)}>View More</button> :
                        <button onClick={()=> setViewMore(true)}>View Less</button>
                    }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* end  table */}
    </div>
  );
};

export default ListInvoice;
